import React, { Component } from 'react'
import { Logo } from '../../components/Layout'
import { LoginOrganizationForm, LoginForm } from './components'

export default class extends Component {
  render () {
    const { organization, getOrganizationByName, getUser, authorize, auth } = this.props

    return (
      <div className='login app__login'>
        <div className='login__container'>
          <div className='login__wrapper'>
            <div className='login__logo'>
              <Logo width='64' />
            </div>
            { organization.data.name.length === 0
              ? <div className='login__content'>
                <LoginOrganizationForm
                  getOrganizationByName={getOrganizationByName}
                  organization={organization} />
              </div>
              : <div className='login__content'>
                <LoginForm
                  authorize={authorize}
                  getUser={getUser}
                  organization={organization}
                  auth={auth} />
              </div>
            }
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/Login/Login.jsx